import { MockConfig } from '.'
import { handlePaymentMethodsMock } from './paymentMethods'
import { handleSellersMock } from './sellers'
import { handleShippingMethodsMock } from './shippingMethods'
import {
  handleGetTemplateByIdMock,
  handlePostTemplateMock,
} from './templates'

export const MOCKED_ENDPOINTS: MockConfig[] = [
  {
    path: /^seller-register\/pvt\/sellers/,
    method: 'GET',
    delay: 500,
    handler: handleSellersMock,
    active: false,
  },
  {
    path: /^logistics\/pvt\/configuration\/freights/,
    method: 'GET',
    delay: 300,
    handler: handleShippingMethodsMock,
    active: false,
  },
  {
    path: /^pvt\/merchants\/payment-systems/,
    method: 'GET',
    delay: 300,
    handler: handlePaymentMethodsMock,
    active: false,
  },
  {
    path: /^admin-promotions-storage-manager\/promotion\/template\/[^/]+$/,
    method: 'GET',
    delay: 300,
    handler: handleGetTemplateByIdMock,
    active: true,
  },
  {
    path: /^admin-promotions-storage-manager\/promotion\/template$/,
    method: 'POST',
    delay: 300,
    handler: handlePostTemplateMock,
    active: true,
  },
]
